<template>
    <tr class="cart-table__row">
        <td class="cart-table__column cart-table__column--quantity" data-title="Item">
            <div class="cart-table__quantity input-number--order-entry" data-title="Item">
                <input class="form-control-order-entry-field-product" type="text" placeholder="Enter Item Number" 
                data-title="Item" @change.prevent="changeItemCode($event.target.value)" v-model="searchkeyword" 
                @keypress.enter.prevent="keywordSearch" @focus="focus" @keyup.down="down"  @keyup.up="up" @input='change'
                :list="'ditem_list_'+ index" />
                <datalist :id="'ditem_list_' + index">
                    <option v-for="(suggestion,index) in api_results" :value="suggestion" :key="index" class="" >{{suggestion}}</option>
                </datalist>
            </div>
        </td>
        <td class="cart-table__column cart-table__column--quantity" data-title="Quantity">
            <base-quantity-input v-model="quantity" @changedQty="changedQty(quantity)"></base-quantity-input>
        </td>
        <td class="cart-table__column cart-table__column--product">
            <div class="text-cart-item-number"><font class="text-cart-item-number"></font></div> 																			
            <div class="text-cart-item-manufacturer"><font class="text-cart-item-manufacturer"></font></div>	
            <div class="cart-table__quantity input-select form-control-vendor-select-returns">
                <select id="stock-order-vendor-select" class="form-control form-control-vendor-select select2-selection--vendor-select" v-model="sel_reason" @change.prevent="changeItemReason($event.target.value)">
                    <option value="" selected>Select Return Reason</option>
                    <option v-for="(rs) in reasons" :key="rs.code" :value="rs.code">{{rs.description}}</option>
                </select>
            </div>
        </td>
        <!-- <td class="cart-table__column cart-table__column--quantity" data-title="MFG">
            <div class="cart-table__column---order-entry-mfg">
                <input :list="'dlist_'+ index" class="form-control-order-entry-field-mfg-code" name="inptdl-mfgc" @change.prevent="changeMFGCode($event.target.value)" placeholder="" :value="part.manufacturer" type="text" />
                <datalist :id="'dlist_' + index">
                    <option v-for="mfgs in manufacturers" :value="mfgs.MFG_CODE" :key="mfgs.MFG_CODE" class="" >{{mfgs.MFG_CODE}}</option>
                </datalist>
            </div>
        </td> -->
        <td class="cart-table__column cart-table__column--product" data-title="Price">
            <p class="cart-table__column--product cart-table__column--product-return">
                <strong></strong><br />
                <strong v-if="part.isValid == 'Y'">{{part.item_validation}}</strong>
                <strong v-if="part.isValid == 'N'"><font class="text-currently-unavailable">Invalid Item</font></strong>
                <br />
            </p>
        </td>
        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Approved QTY">
            <div class="cart-table__quantity input-number--order-entry return-columns-text">
                <p class="">
                    <strong><font class="text-return-columns">{{part.QAPRVD}}</font></strong>
                </p>
            </div>
        </td>
        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Item Credit">
            <div class="cart-table__quantity input-number--order-entry return-columns-text">
                <p class="">
                    <strong><font class="text-return-columns">{{part.QEXTPRC}}</font></strong>
                </p>
            </div>
        </td>
        <td class="cart-table__column cart-table__column--remove">
            <svg width="25" height="25" viewBox="0 0 32 32" class="cart-X-svg cart-table__remove" @click="removeItem">
                <path d="M25.313 9.229l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
            </svg>
        </td>
    </tr>
</template>

<style>
    .form-control-order-entry-field-mfg-code{
        min-width: 70px;
    }
</style>
<script>

import axios from 'axios';
import axiosvl from "../../../axios/axios-vl.js";

export default {
    props: {
        part: {
            
        },
        index: {
            type: Number
        },
        dparts: {
            type: Array
        }
    },
    data() {
        return {
            reasons: [],
            sel_reason: '',
            searchkeyword: '',
            quantity: 0,
            seldup: null,
            api_results: [],
            // linetotal: 0,
        };
    },
    watch: {
        seldup(newVal) {
            this.$emit('update_mfg_code', this.index, newVal);
        }
    },
    computed: {
        manufacturers() {
            // const mfgs = [];
            const wd_mdfgs = this.$store.getters.wd_mfgs;
            return wd_mdfgs;
        },
        linetotal() {
            return this.quantity * this.part.EIEXCP;
        },

        classStock(){
            if(this.part.isValid == 'N'){
                return 'text-currently-unavailable';
            }

            if(this.part.isValid == 'Y'){
                return 'text-available';
            }

            return '';
        },

        stockStatus(){
            if(this.part.isValid == 'N'){
                return 'INVALID';
            }

            if(this.part.isValid == 'Y'){
                return 'VALID';
            }
            
            return '';
        },

    },

    emits: [
        'update_qty', 'update_item_code', 'update_mfg_code', 'remove_item', 'update_reason'
    ],

    methods: {
        /** fetch reasons from web service */
        fetchNonRMAReasons() {
            const return_nonrma_reasons_uri = this.$store.getters['api/return_nonrma_reasons_uri'];
            axiosvl.post(return_nonrma_reasons_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                        },
                    }
                }
            )
            .then((response) => {
                const REASONS = response.data.webroutine.lists.NONRMAREASONS.entries;
                this.reasons = [];

                for (const key in REASONS) {
                    const obj = REASONS[key];
                    
                    this.reasons.push({
                        code: obj.RSREAS,
                        description: obj.RSDESC,
                    });
                }
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        async solr_search() {

            const solr_host = this.$store.getters.solr_hostname + '/solr/' + this.$store.getters.solr_coreadmin;
            const itemf = this.searchkeyword.toUpperCase();
            let uri = solr_host + '/select?fl=Item&indent=true&q.op=AND&q=Item%3A*' + itemf + '*&group=true&group.field=Item';

            await axios.get(uri,{
                auth: {
                    username: this.$store.getters.solr_username,
                    password: this.$store.getters.solr_password
                }
            })
            .then((response) => {
                this.api_results = [];
                response.data.grouped.Item.groups.forEach(grp => {
                    this.api_results.push(grp.groupValue);
                });
            });
        },

        search_api() {

            axiosvl.post(this.$store.getters['api/search_typeahead_uri'], 
				{
					"webroutine": {
						"context": {
							"session-key-method": "hidden"
						},
						"fields": {
							"EHCUST": {
								"value": this.$store.getters.customer
								// "value": "DMS"
							},
                            "TYPEAHEAD" : {
                                "value": this.searchkeyword
                            }
						}
					}
				}
			).then((response) => { 
                const fields = response.data.webroutine.fields;
                const res_withspaces = [];
                this.api_results = [];
				for (const key in response.data.webroutine.lists.PDESCS.entries) { 
					const obj = response.data.webroutine.lists.PDESCS.entries[key];
                    if(obj.TADESCR.indexOf(' ') >= 0) {
                        res_withspaces.push(obj.TADESCR);	
                    }else{
                        this.api_results.push(obj.TADESCR);
                    } 
				}
                this.api_results = this.api_results.concat(res_withspaces);

                if (fields.NREC.value > 0){
                    this.open = true;
                }

			}).catch(function (error) { 
				console.error("error - " + error);
			});
        },

        //When up pressed while suggestions are open
        up() {
            if(this.current > 0)
                this.current--;
        },

        //When up pressed while suggestions are open
        down() {
            if(this.current < this.api_results.length - 1)
                this.current++;
        },

        //For highlighting element
        isActive(index) {
            return index === this.current;
        },

        //When the user changes input
        change() {
            this.solr_search();
            if (this.open == false) {
                this.open = true;
                this.current = 0;
            }
        },

        //When one of the suggestion is clicked
        suggestionClick(select) {
            this.searchkeyword = '';
            this.selected = select;
            this.open = false;
            this.selected = this.selected.replaceAll('"', '');
            // this.$emit("selectedSearch", this.selected);
        },


        changedQty(newQty) {
            this.quantity = newQty;
            this.$emit('update_qty', this.index, newQty);
        },

        changeItemCode(newVal){
            this.$emit('update_item_code', this.index, newVal);
        },

        changeMFGCode(newVal){
            this.$emit('update_mfg_code', this.index, newVal);
        },

        changeItemReason(newVal){
            this.$emit('update_reason', this.index, newVal);
        },

        removeItem() {
            this.$emit('remove_item', this.index);
        },

        updateRow(item, qty) {
            this.searchkeyword = item;
            this.quantity = qty;
        }
    },


    mounted (){
        this.fetchNonRMAReasons();

        // console.log(this.part);
        // console.log(this.$route.params.saved);
        if(this.$route.params.saved != null  && this.$route.params.saved != ''){
            // setTimeout(() => {
            //     // console.log(this.part);
            //     this.searchkeyword = this.part.item;
            //     this.quantity = this.part.quantity;
            // }, 2000);
        }
    },


    updated() {
        
    }
}
</script>